import { Base } from '@studiometa/js-toolkit';

/**
 *
 */
export default class Newsletter extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Newsletter',
    refs: ['form', 'email', 'btn', 'loader'],
  };

  /**
   *
   */
  mounted() {
    this.submit();
  }

  /**
   * Get action value
   * @returns {string} value.
   */
  get action() {
    return this.name.action;
  }

  /**
   * Handles form submission with hCaptcha validation and processes the newsletter signup
   */
  submit() {
    this.$refs.btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (this.$el.querySelector('.alert')) {
        this.$el.querySelector('.alert').remove();
      }
      this.$refs.loader.classList.remove('hidden');
      this.$refs.loader.classList.add('block');
      // Hcaptcha est monter lors du clique sur un champs
      // c'est le comportement par defaut de shopify
      // Je force donc l'execution de hcaptcha pour récupérer le token

      hcaptcha.execute();
      observeDataHcaptchaResponse(this.$refs.form);
    });

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-hcaptcha-response') {
          const value = mutation.target.dataset.hcaptchaResponse;
          if (value?.trim()) {
            const formData = new FormData(this.$refs.form);
            fetch('/contact', {
              method: 'POST',
              body: formData,
            })
              .then((response) => response.text())
              .then((data) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, 'text/html');
                const successElement = doc.querySelector('#ContactFooter-success');
                const newDiv = document.createElement('h3');
                this.$refs.loader.classList.remove('block');
                this.$refs.loader.classList.add('hidden');

                let newContent = '';

                if (successElement) {
                  newContent = document.createTextNode(successElement.textContent.trim());
                } else {
                  newContent = document.createTextNode(
                    "Une erreur s'est produite, veuillez ressayer plus tard.",
                  );
                }

                newDiv.classList.add(
                  'alert',
                  'text-base',
                  'text-white',
                  'font-light',
                  'mt-2',
                  'text-right',
                  'absolute',
                  '-bottom-8',
                );
                newDiv.append(newContent);
                const currentDiv = this.$refs.form;
                currentDiv.append(newDiv);
                this.$refs.email.value = '';
                
                setTimeout(() => {
                  newDiv.remove();
                }, 1000)

              })
              .catch((error) => {
                console.error('Error submitting form:', error);
              });
          }
        }
      }
    });

    /**
     * @param {HTMLFormElement} form The form element containing the hCaptcha iframe
     */
    function observeDataHcaptchaResponse(form) {
      const iframe = form.querySelector('iframe[data-hcaptcha-response]');
      if (iframe) {
        observer.observe(iframe, {
          attributes: true,
          attributeFilter: ['data-hcaptcha-response'],
        });

        // Valeur initiale éventuelle
        const initialValue = iframe.dataset.hcaptchaResponse;
        if (initialValue) {
          console.log('data-hcaptcha-response initial:', initialValue);
        }
      } else {
        // Attente du chargement dynamique de l’iframe
        setTimeout(() => observeDataHcaptchaResponse(form), 500);
      }
    }
  }
}
